import { Badge, Container, Text } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';

type PlanCardHeaderProps = {
  title: string;
  description: string;
  isCurrentPlan: boolean;
  isMostPopular: boolean;
};

export const PlanCardHeader = ({ title, isCurrentPlan, isMostPopular }: PlanCardHeaderProps) => {
  const { formatMessage } = useMelioIntl();

  const getBadgeTitle = () => {
    if (isCurrentPlan) {
      return formatMessage('activities.subscription.plans.card.activePlan');
    }

    if (isMostPopular) {
      return formatMessage('activities.subscription.plans.card.mostPopular');
    }

    return;
  };

  const badgeTitle = getBadgeTitle();
  const badgeType = isCurrentPlan ? 'secondary' : 'primary';

  return (
    <Container>
      <Container justifyContent="space-between" alignItems="center" paddingBottom="s">
        <Text as="h2" textStyle="heading3Semi">
          {title}
        </Text>

        {!!badgeTitle && <Badge label={badgeTitle} status="brand" type={badgeType} />}
      </Container>

      <Text textStyle="body3">{formatMessage('activities.subscription.plans.description')}</Text>
    </Container>
  );
};
